import axios from 'axios'

const apiService = axios.create({
  baseURL: 'https://api.aurealestate.org/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Intercepteur pour ajouter le token d'authentification
apiService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Intercepteur pour gérer les erreurs globalement
apiService.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // Gérer les erreurs d'authentification
      if (error.response.status === 401) {
        localStorage.removeItem('token')
      }
      
      // Gérer les erreurs de validation
      if (error.response.status === 422) {
        return Promise.reject(error.response.data)
      }
    }
    return Promise.reject(error)
  }
)

export default {
  // Méthodes génériques
  async get(endpoint) {
    const response = await apiService.get(endpoint)
    return response.data
  },

  async post(endpoint, data) {
    const response = await apiService.post(endpoint, data)
    return response.data
  },

  async put(endpoint, data) {
    const response = await apiService.put(endpoint, data)
    return response.data
  },
  
  async patch(endpoint, data) {
    const response = await apiService.patch(endpoint, data)
    return response.data
  },

  async delete(endpoint) {
    const response = await apiService.delete(endpoint)
    return response.data
  },

  // Méthode spéciale pour l'upload de fichiers
  async uploadFile(endpoint, formData) {
    const response = await apiService.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  // Méthode spéciale pour la mise à jour avec fichiers (PUT)
  async updateWithFile(endpoint, formData) {
    const response = await apiService.put(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }
} 